const trimTrailingSlashes = (value = "") => value.replace(/\/+$/, "")
const normalizePath = (value = "") => {
  if (!value) return ""
  return value.startsWith("/") ? value : `/${value}`
}

const explicitApiBaseURL = trimTrailingSlashes(import.meta.env.REACT_APP_API_BASE_URL || "")

const config = {
  api: {
    host: import.meta.env.REACT_APP_API_HOST || "127.0.0.1",
    port: import.meta.env.REACT_APP_API_PORT ?? 8081,
    basePath: import.meta.env.REACT_APP_API_BASE_PATH || "/api",
    protocol: import.meta.env.REACT_APP_API_PROTOCOL || "http",
    get baseURL() {
      if (explicitApiBaseURL) {
        return explicitApiBaseURL
      }

      const rawPort = String(this.port ?? "").trim()
      const portSegment = rawPort ? `:${rawPort}` : ""
      return `${this.protocol}://${this.host}${portSegment}${normalizePath(this.basePath)}`
    },
  },
  versionName: import.meta.env.REACT_APP_NAME || "Test",
  ingresosColumns: import.meta.env.REACT_APP_INGRESOS_COLUMNS || null,
  reconocimientoColumns: import.meta.env.REACT_APP_RECONOCIMIENTO_COLUMNS || null,
  basename: import.meta.env.REACT_APP_BASENAME || "",
  embedParentOrigin: import.meta.env.REACT_APP_EMBED_PARENT_ORIGIN || "*",
  turnstileSiteKey: import.meta.env.REACT_APP_TURNSTILE_SITE_KEY || "",
}
export default config
